/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Run_SkippedInputs */

const vi_irrigation_run_skipped = /** @type {(inputs: Irrigation_Run_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bơm ${i?.name} chưa bật được`)
};

/**

* @param {Irrigation_Run_SkippedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_skipped = /** @type {((inputs: Irrigation_Run_SkippedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_SkippedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_skipped(inputs)
});